import { Button, Divider, ListItemIcon, ListItemText, MenuItem, MenuList, styled, Typography } from '@mui/material';
import { useState } from 'react';
import { StyledMenu, SubmenuProps } from '../SubMenus';
import { LogoutOutlined } from '@mui/icons-material';
import Images from '../../InfoCard/Details/Images';
import { colors } from '../../../utils/palette';

export interface ProfileMenuProps {
  menuItems: SubmenuProps[];
  full_name: string;
  imageSrc: string;
  company: string;
  logoutFunction: () => void;
}

const ProfileMenu: React.FC<ProfileMenuProps> = ({ menuItems, imageSrc, full_name, company, logoutFunction }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ProfileMenuButton id="customized-button" data-testid="profile-button" disableElevation onClick={handleClick} selected={!!anchorEl}>
        <Images type="imageDetail" images={[{ src: imageSrc, imgWidth: 40, imgHeight: 40, cornerRadius: 4 }]} />
      </ProfileMenuButton>

      <StyledMenu
        id="customized-menu"
        MenuListProps={{
          'aria-labelledby': 'customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuList>
          <MenuItem>
            <ListItemIcon>
              <Images type="imageDetail" images={[{ src: imageSrc, imgWidth: 40, imgHeight: 40, cornerRadius: 4 }]} />
            </ListItemIcon>
            <ListItemText sx={{ ml: 1 }}>
              <Typography variant="body2" style={{ fontWeight: 600 }}>
                {full_name}
              </Typography>
              <Typography variant="body2" sx={{ color: 'primary.textSecondary', fontSize: 12 }}>
                {company}
              </Typography>
            </ListItemText>
          </MenuItem>
          <Divider style={{ width: '100%' }} />
          {menuItems.map((menuItem) => {
            return (
              <MenuItem key={menuItem.buttonTitle} onClick={menuItem.link}>
                <ListItemIcon>{menuItem.buttonIcon}</ListItemIcon>
                <ListItemText>
                  <Typography variant="body2">{menuItem.buttonTitle}</Typography>
                </ListItemText>
              </MenuItem>
            );
          })}
        </MenuList>
        <Divider style={{ width: '100%' }} />
        <MenuItem onClick={logoutFunction}>
          <ListItemIcon>
            <LogoutOutlined />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body2">Logout</Typography>
          </ListItemText>
        </MenuItem>
      </StyledMenu>
    </>
  );
};

export default ProfileMenu;

const ProfileMenuButton = styled(Button)<{ selected?: boolean }>(({ selected, theme }) => ({
  backgroundColor: selected ? colors.lightSecondary : theme.palette.background.default,
  color: theme.palette.text.secondary,
  width: theme.spacing(5),
  height: theme.spacing(5),
  minWidth: theme.spacing(5),
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& svg': {
    fill: selected ? theme.palette.primary.main : theme.palette.text.secondary,
  },
}));
